import React from "react";
import { useTranslation } from "react-i18next";

export default function Confiance() {
  const { t } = useTranslation();

  const STATS = [
    { num: t("confiance_stat1_num"), imp: t("confiance_stat1_imp"), lab: t("confiance_stat1_lab") },
    { num: t("confiance_stat4_num"), imp: t("confiance_stat4_imp"), lab: t("confiance_stat4_lab") },
    { num: t("confiance_stat2_num"), imp: t("confiance_stat2_imp"), lab: t("confiance_stat2_lab") },
    { num: t("confiance_stat3_num"), imp: t("confiance_stat3_imp"), lab: t("confiance_stat3_lab") },
    
  ];
  return (
    <div className="mt-24 wrapper xl:mt-24">
      <h1 data-anchor-title className="text-4xl font-bold text-center md:text-5xl md:mb-20" data-aos="zoom-in">
        {t("confiance_title")}
        <span className="text-primOrange"> {t("confiance_title_accent")}</span>
      </h1>

      <p className="paragraph text-center mt-6 mx-auto max-w-3xl md:mt-0">
        {t("confiance_tagline")} {t("confiance_tagline_reduire")} {t("confiance_tagline_et")}{" "}
        {t("confiance_tagline_augmenter")} {t("confiance_tagline_end")}
      </p>
      <div
        className="flex flex-wrap justify-center gap-y-10 gap-x-4 border-y-2 border-primary mt-10 py-12 md:mt-14"
        data-aos="fade-up"
      >
        {STATS.map((stat, i) => (
          <div key={i} className="flex flex-col items-center gap-4 text-center w-[calc(50%-1rem)] md:w-[calc(33.333%-1rem)] max-w-[250px]">
            <div className="px-8 py-2 bg-primOrange rounded-[50px] font-bold md:px-10 md:py-3 md:text-md">
              <p className="text-4xl font-bold text-white md:text-5xl">
                {stat.num}            
              </p>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-sm font-bold md:text-base max-w-[200px]">{stat.imp}</span>
              <span className="text-sm md:text-base max-w-[200px]">{stat.lab}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}